<template>
    <dialogBox >
        <template v-slot:title>{{ $t('Comment') }}</template>
        <template v-slot:body>
            <div class="mb-3">
                <span class="fs-14 badge bg-info copy mb-2" @click="this.form.comment = this.$t('notInterest')" style="margin-right: 5px;">{{ $t('notInterest') }}</span>
                <span class="fs-14 badge bg-info copy mb-2" @click="this.form.comment = this.$t('Не відповів')" style="margin-right: 5px;">{{ $t('Не відповів') }}</span>
            </div>
            <div class="mb-3">
                <label class="form-label">{{ $t('Comment') }}</label>
                <textarea class="form-control" rows="3" v-model="form.comment" ></textarea>
            </div>
        </template>
        <template v-slot:footer-bottom>
            <button class="btn link-success fw-medium"  @click="this.$emit('close')"><i class="ri-close-line me-1 align-middle"></i> {{ $t('cancel') }} </button>
            <button 
                type="button" 
                class="btn btn-primary" 
                @click="toClose"
            >
                {{ $t('Add') }}
            </button>
        </template>
    </dialogBox>
</template>

<script>
import dialogBox from '@/components/modal/dialog'
import "flatpickr/dist/flatpickr.min.css";
import flatpickr from "flatpickr";
import { Russian } from "flatpickr/dist/l10n/ru.js";
import { Ukrainian } from "flatpickr/dist/l10n/uk.js";
import Vueflatpickr from "vue-flatpickr-component";
import { storeS } from '@/store';

export default{
    components: {
        dialogBox,
        flatpickr: Vueflatpickr
    },
    props: ['id'],
    data(){
        return{
            form: {
                comment: '',
            },
        }
    },
    created() {
    },
    methods: {
        toClose(){
            if(this.form.comment == '') {
                this.$toast.error(this.$t('enterComment'))
            } else {
                this.$emit('toClose', this.id, this.form)
                this.$emit('close')
            }
        }
    }
}
</script>